import axios from "axios";
import ComentariosModel from "../components/comentarios/comentarios.model";
import { environment } from "../environments/environment";

export const api = axios.create({
    baseURL: environment.serverUrl
});

const config: any = {
    headers: {}
};

export async function ListarComentariosService(dto: ComentariosModel) {
    let url = '/listar-comentarios';
    return await api.post(url, dto, config);
}

export async function InserirComentarioService(dto: ComentariosModel) {
    let url = '/inserir-comentarios';
    return await api.post(url, dto, config);
}